import { Icon } from "@iconify/react";
import androidFilled from "@iconify/icons-ant-design/android-filled";
import layersFill from "@iconify/icons-eva/layers-fill";
// material
import { alpha, styled } from "@mui/material/styles";
import { Card, Typography } from "@mui/material";
// utils
import { fShortenNumber } from "../../../utils/formatNumber";
import { ResponseModel } from "../../../types/ResponseModel";
import { categoryService } from "../../../services/categoryService";
import { useEffect, useState } from "react";
import React from "react";

// ----------------------------------------------------------------------

const RootStyle = styled(Card)(({ theme }) => ({
  boxShadow: "none",
  textAlign: "center",
  padding: theme.spacing(5, 0),
  color: theme.palette.warning.darker,
  backgroundColor: theme.palette.warning.lighter,
}));

const IconWrapperStyle = styled("div")(({ theme }) => ({
  margin: "auto",
  display: "flex",
  borderRadius: "50%",
  alignItems: "center",
  width: theme.spacing(8),
  height: theme.spacing(8),
  justifyContent: "center",
  marginBottom: theme.spacing(3),
  color: theme.palette.warning.dark,
  backgroundImage: `linear-gradient(135deg, ${alpha(
    theme.palette.warning.dark,
    0
  )} 0%, ${alpha(theme.palette.warning.dark, 0.24)} 100%)`,
}));
// ----------------------------------------------------------------------

const TOTAL = 714000;

export default function DashboardCategory() {
  const [totalKategori, setTotalKategori] = useState(0);
  useEffect(() => {
    categoryService
      .getTotalCount()
      .then(({ data }: { data: ResponseModel }) => {
        setTotalKategori(data.data);
      });
  }, []);
  return (
    <RootStyle>
      <IconWrapperStyle>
        <Icon icon={layersFill} width={24} height={24} />
      </IconWrapperStyle>
      <Typography variant="h3">{fShortenNumber(totalKategori)}</Typography>
      <Typography variant="subtitle2" sx={{ opacity: 0.72 }}>
        Kategori Sayısı
      </Typography>
    </RootStyle>
  );
}
